module.exports = __webpack_public_path__ + "static/media/24UHCHR16.0768a166.jpg";